// services/faqService.ts
import axios from "axios";
import { Faq, FaqToBackend } from "../types/features/Faq";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const faqService = {
  // 🔓 PUBLIC - Pas de token nécessaire
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Faq>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/faqs`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des FAQ", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getById(id: string): Promise<Faq> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/faqs/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de la FAQ", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async create(token: string, data: FaqToBackend): Promise<Faq> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/faqs`, {
        ...data,
         product_name: data.product_name || 'all',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de la FAQ", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<FaqToBackend>): Promise<Faq> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/faqs/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la FAQ", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/faqs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de la FAQ", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      const promises = ids.map((id) => this.delete(token, id));
      await Promise.all(promises);
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async reorder(token: string, ids: string[]): Promise<void> {
    try {
      await axios.post(`${MAIN_API_URL}/faqs/reorder`, { ids }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors du réordonnancement", error);
      throw error;
    }
  },
};